import axios, { AxiosError } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';

import config from '../config';
const log = getLogger('simManagement.api.mvnoTemplateApi');

export interface MvnoTemplate {
  id: string;
  templateName: string;
  friendlyName: string;
}

export function getTemplates(accountId: number, networkId: number): Promise<MvnoTemplate[]> {
  const url = config.API_BASE_URL + `api/account/${accountId}/provisioningTemplates?networkId=${networkId}`;
  return new Promise<MvnoTemplate[]>((resolve, reject) => {
    axios
      .get(url)
      .then((response: any) => {
        const result = response.data as MvnoTemplate[];
        resolve(result);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to load esimsmart templates', simManagementError);
        reject(simManagementError);
      });
  });
}
